import { render, staticRenderFns } from "./cloud_stock_log_list.vue?vue&type=template&id=515cdb88&scoped=true"
import script from "./cloud_stock_log_list.vue?vue&type=script&lang=js"
export * from "./cloud_stock_log_list.vue?vue&type=script&lang=js"
import style0 from "./cloud_stock_log_list.vue?vue&type=style&index=0&id=515cdb88&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515cdb88",
  null
  
)

export default component.exports